import { apiClient } from "../client";
import handleError from "../../utilities/api-helpers/handleError";
import tcWrap from "../../utilities/generic-helpers/tcWrap";

export const getnotificationList = (page) =>
  tcWrap(async () => {
    const data = await apiClient.get(`/user/notification_listing?page=${page}`).catch(handleError);
    return data;
  });
